import {
	buildFormDataFromRecord,
	getCoverageTableConfig,
	resolveSchemaFromRecord,
} from "./coverageDrilldownConfig";

const API_BASE_PATH =
	process.env.NODE_ENV === "production"
		? process.env.REACT_APP_PROD_API_BASE_PATH
		: process.env.REACT_APP_DEV_API_BASE_PATH;

const API_BASE_ORIGIN =
	process.env.NODE_ENV === "production"
		? window.location.origin
		: process.env.REACT_APP_DEV_API_BASE_URL;

const USE_MOCK_API = true;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const buildCoverageApiUrl = (tableKey, { id } = {}) => {
	const tableConfig = getCoverageTableConfig(tableKey);
	if (!tableConfig) return null;

	const url = new URL(
		`${API_BASE_PATH}/ftth_coverage/${tableConfig.apiSegment}`,
		API_BASE_ORIGIN
	);

	if (id) {
		url.searchParams.set("id", id);
	}

	return url;
};

const buildMockRecord = (tableKey, id) => {
	const tableConfig = getCoverageTableConfig(tableKey);
	const isPop = tableKey === "blacklist_pop";

	return {
		id: id || "00000000-0000-4000-8000-000000000001",
		...(isPop
			? {
					popId: "POP-MIL-001",
					reason: "Coverage restriction",
					notes: "Mock record — replace when API is connected",
					active: "true",
			  }
			: {
					egonId: "EGON-123456",
					customerId: "503034350",
					reason: "Manual exclusion",
					notes: "Mock record — replace when API is connected",
					active: "true",
			  }),
		json_schema: tableConfig?.defaultSchema || {},
	};
};

export const fetchCoverageRecord = async (tableKey, id) => {
	if (!getCoverageTableConfig(tableKey)) {
		throw new Error("Unsupported coverage table.");
	}

	if (!id) {
		throw new Error("Record id is required.");
	}

	if (USE_MOCK_API) {
		await delay(450);
		const record = buildMockRecord(tableKey, id);
		const tableConfig = getCoverageTableConfig(tableKey);
		return {
			record,
			schema: resolveSchemaFromRecord(record, tableConfig),
			formData: buildFormDataFromRecord(record, tableConfig),
		};
	}

	const url = buildCoverageApiUrl(tableKey, { id });
	if (!url) throw new Error("Unable to build API URL.");

	throw new Error("Live API not configured yet.");
};

export const saveCoverageRecord = async (tableKey, payload) => {
	if (!getCoverageTableConfig(tableKey)) {
		throw new Error("Unsupported coverage table.");
	}

	if (USE_MOCK_API) {
		await delay(500);
		return { result: true, data: payload };
	}

	throw new Error("Live API not configured yet.");
};

export const deleteCoverageRecord = async (tableKey, id) => {
	if (!getCoverageTableConfig(tableKey)) {
		throw new Error("Unsupported coverage table.");
	}

	if (!id) {
		throw new Error("Record id is required.");
	}

	if (USE_MOCK_API) {
		await delay(500);
		return { result: true };
	}

	throw new Error("Live API not configured yet.");
};

export const createEmptyRecord = (tableKey) => {
	const tableConfig = getCoverageTableConfig(tableKey);
	if (!tableConfig) return null;

	const isPop = tableKey === "blacklist_pop";
	const record = {
		id: null,
		...(isPop
			? { popId: "", reason: "", notes: "", active: "true" }
			: {
					egonId: "",
					customerId: "",
					reason: "",
					notes: "",
					active: "true",
			  }),
	};

	return {
		record,
		schema: tableConfig.defaultSchema,
		formData: buildFormDataFromRecord(record, tableConfig),
	};
};
